import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 6H10v6H8V4h6V0H6v6H2v16h20V6z"
}), 'MarkunreadMailboxSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MarkunreadMailboxSharp.js
// module id = 4780
// module chunks = 2